import { Component, HostListener, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DxButtonModule, DxCheckBoxModule, DxDataGridModule, DxDropDownBoxModule, DxFormModule, DxHtmlEditorModule, DxPopupModule, DxSelectBoxModule, DxTagBoxModule, DxTextBoxModule } from 'devextreme-angular';
import { DxHtmlEditorComponent } from 'devextreme-angular';
import { FormControl } from '@angular/forms';
import { ContactService } from 'src/app/services/contact.service';
import { AppGlobals } from 'src/app/app.globals';
import { MessagingService } from 'src/app/services/messaging.service';
import { DeletePopupComponent } from 'src/app/components/delete-popup/delete-popup.component';
import { SearchableDropdownDirective } from '../../../directives/searchable-dropdown.directive';
@Component({
    selector: 'app-email-editor',
    imports: [CommonModule,
        DxHtmlEditorModule,
        DxCheckBoxModule,
        DxSelectBoxModule,
        DxButtonModule,
        DxDropDownBoxModule,
        DxDataGridModule,
        DxPopupModule,
        DxTextBoxModule,
        DxTagBoxModule,
        DxFormModule,
        DeletePopupComponent, SearchableDropdownDirective],
    templateUrl: './email-editor.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./email-editor.component.css']
})
export class EmailEditorComponent implements OnInit {
  toDeleteData: any = {};

  popupActive: boolean = false;

  valueContent: any;

  predefinedOptions: any = [
    { text: $localize`@@ProjectId`, displayText: $localize`ProjectId` },
    { text: $localize`@@ProjectName`, displayText: $localize`ProjectName` },
    { text: $localize`@@ProjectSize`, displayText: $localize`ProjectSize` },
    { text: $localize`@@ProjectAddress`, displayText: $localize`ProjectAddress` },
    { text: $localize`@@Longitude`, displayText: $localize`Longitude` },
    { text: $localize`@@Latitude`, displayText: $localize`Latitude` },
    { text: $localize`@@SiteId`, displayText: $localize`SiteId` },
    { text: $localize`@@SiteName`, displayText: $localize`SiteName` },
    { text: $localize`@@ProjectType`, displayText: $localize`ProjectType` },
    { text: $localize`@@ProjectPhase`, displayText: $localize`ProjectPhase` },
    { text: $localize`@@ProjectStatus`, displayText: $localize`ProjectStatus` },
    { text: $localize`@@PartnerName`, displayText: $localize`PartnerName` },
    { text: $localize`@@EPCName`, displayText: $localize`EPCName` },
    { text: $localize`@@ProjectDeveloper`, displayText: $localize`ProjectDeveloper` },
    { text: $localize`@@ProjectTechnicalLead`, displayText: $localize`ProjectTechnicalLead` },
    { text: $localize`@@ProjectFinance`, displayText: $localize`ProjectFinance` },
    { text: $localize`@@ProjectDistribution`, displayText: $localize`ProjectDistribution` },
    { text: $localize`@@ProjectLead`, displayText: $localize`ProjectLead` }
  ];
  windowHeight: any;
  isMultiline = true;

  variableCatalog: any = [
    {
      category: 'project', variables: [
        { name: 'Project Nr', value: '{projectNr}' },
        { name: 'Project Name', value: '{projectName}' }]

    }

  ]

  draggedText: string;

  emailData: any = {};

  recipientsList: any = [];

  emailTemplateEditorVisible: boolean = false;

  userPermissions: boolean = AppGlobals.UserPermissions;

  allEmailTemplatesList: any = [];

  deleteEmailTemplateConfirmVisible: boolean = false;

  constructor(
    private contactService: ContactService,
    private messagingService: MessagingService

  ) {
    this.emailData = {
      subject: null,
      recipients: [],
      emailHtml: this.valueContent
    };

  }

  ngOnInit(): void {
    this.calculateEditorHeight();
    this.getPersonList();
    this.getEmailTempaltes();
  }

  getEmailTempaltes(): void {


    this.messagingService.getAllMailTemplates({}).then((result) => {
      if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
      else {
        this.allEmailTemplatesList = result.templates;
      }
    },
      (error: any) => {
        AppGlobals.ShowErrorMessage(error);
      });

  }


  getPersonList(): void {
    this.contactService.getPersons({}).then((result) => {
      if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
      else {
        this.recipientsList = result.personItems;
      }
    },
      (error: any) => {
        AppGlobals.ShowErrorMessage(error);
      });
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.calculateEditorHeight(); // Recalculate height when window is resized
  }

  insertVariable(e) {
    e.component.insertEmbed('variable', 'variable', {
      variable: e.value
    });
  }

  save() {
    this.popupActive = true;
  }

  calculateEditorHeight(): void {
    var windowHeight = window.innerHeight - 240;
    this.windowHeight = windowHeight;
  }


  logRecipientsList(event: any): void {
  }

  async saveEmailData() {

    /*     var recipientsList = '';
        for (let i = 0; i < this.emailData.recipients.length; i++) {
          recipientsList = recipientsList + (this.emailData.recipients[i] + '; ');
        }
        this.emailData.recipients = recipientsList;
        this.popupActive = false; */
    let htmlBody = JSON.stringify(this.valueContent);
    let templateData = {

      "TemplateData": {
        "TemplateId": null,
        "MailBody": htmlBody,
        "MailSubject": this.emailData.subject,
        "MailTo": this.emailData.recipients
      }

    }

    this.messagingService.writeMailTemplate(templateData).then((result) => {
      if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
      else {
        this.popupActive = false;
        this.emailTemplateEditorVisible = false;
        this.getEmailTempaltes();
      }
    },
      (error: any) => {
        AppGlobals.ShowErrorMessage(error);
      });



  }

  editRow(data: any, idex: any): void {
    this.emailTemplateEditorVisible = true;


    let templateData = {
      "TemplateData": {
        "TemplateId": data.templateId
      }
    }

    this.messagingService.getMailTemplate(templateData).then((result) => {
      if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
      else {
        let emailTemplateData = result.templates[0];
        this.valueContent = emailTemplateData.mailBody;
        this.emailData = {
          subject: emailTemplateData.mailSubject,
          recipients: emailTemplateData.mailTo,
          templateId: emailTemplateData.templateId,
        };
      }
    },
      (error: any) => {
        AppGlobals.ShowErrorMessage(error);
      });


  }


  addEmailTemplate(): void {
    this.emailTemplateEditorVisible = true;
    this.valueContent = null;
    this.emailData = {
      templateId: null,
      subject: null,
      recipients: [],
      emailHtml: this.valueContent
    };
  }

  cancel(): void {
    this.emailTemplateEditorVisible = false;
    this.valueContent = null;
    this.emailData = {
      templateId: null,
      subject: null,
      recipients: [],
      emailHtml: this.valueContent
    };

    ///////reset values if nessisary /////

  }

  deleteTemlpate(data: any, index: any): void {

    this.toDeleteData = { data: data, index: index };
    this.deleteEmailTemplateConfirmVisible = true;

  }

  handleDelete(e: any): void {
    if (e === true) {
      let templateData = {
        "TemplateData": {
          "TemplateId": this.toDeleteData.data.templateId
        }
      }

      this.messagingService.deleteMailTemplate(templateData).then((result) => {
        if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
        else {

          this.deleteEmailTemplateConfirmVisible = false;

          this.getEmailTempaltes();

        }
      },
        (error: any) => {
          AppGlobals.ShowErrorMessage(error);
        });
    }
  }

  backToTemplateEditor(): void {
    this.popupActive = false
  }
}